import resourceSubject from '../reactivity/resource-subject';
import TriggeredGuides from './guides';

export default class TriggeredGuideManager {
  static storageKey = 'user-guide-show-later';

  constructor() {
    this.guides = new TriggeredGuides(this);
    this.subscription = resourceSubject('user-guide').subscribe({
      next: this.handleUserGuideShown.bind(this),
    });
  }

  handleUserGuideShown(event, details = {}) {
    if (event === 'user-guide-shown') {
      const guide = this.guides.find(details.key);
      if (!guide) return;

      this.guides.remove(guide);
      console.debug(`TriggerdGuideManager remove guide ${guide.key}`);
    }
  }

  static saveGuideForShowLater({
    key, category, triggerEvent, triggerAnchorSelector, triggerShowLater,
  }) {
    window.sessionStorage.setItem(this.storageKey, JSON.stringify({
      key, category, triggerEvent, triggerAnchorSelector, triggerShowLater,
    }));
  }

  static retrieveGuideFromShowLater() {
    return JSON.parse(window.sessionStorage.getItem(this.storageKey));
  }

  static clearShowLater() {
    window.sessionStorage.setItem(this.storageKey, null);
  }
}
